import { useTranslation } from 'react-i18next';
import { DrawerPanel } from '@dmc/ui';
import useTabs, { TabConfig } from '@cas/components/tabs/tabs/useTabs';
import Tabs from '@cas/components/tabs/tabs/Tabs';
import Summary from './summary/Summary';
import { ConnectivitySnackbar } from '@dmc/ui';
import useVehicleInteraction from './useVehicleInteraction';
import InteractionHeader from '@customer/components/data-display/interaction-header/InteractionHeader';
import InvestigationButton from '@customer/components/inputs/investigation-button/InvestigationButton';
import { viToInvestigationType } from '@customer/shared/utils/investigationHelper';

export function VehicleInteractionPanel() {
  const { t } = useTranslation();

  const { interaction, error } = useVehicleInteraction();

  const tabConfigs: TabConfig[] = [{ title: t('Summary'), view: <Summary /> }];

  const { activeView, ...tabsProps } = useTabs({ tabConfigs });
  const interactionType = viToInvestigationType(interaction?.it);

  return (
    <>
      <DrawerPanel
        header={<InteractionHeader interactionType={interactionType} interaction={interaction} />}
        tabs={interaction && <Tabs {...tabsProps} hasBorder />}
        footer={
          interaction && !interaction.invest && <InvestigationButton interaction={interaction} />
        }
      >
        {interaction && activeView}
      </DrawerPanel>

      <ConnectivitySnackbar error={error} message={t('FetchEventError')} title={t('Error')} />
    </>
  );
}

export default VehicleInteractionPanel;
